import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  isObjectEmpty,
  getMessage,
  setDomiciliationMsgInitialDate,
  formatEpochDate,
} from "../../organisms/utils";
import { getMessengerService, executeTaggeo } from "../../../store/actions";
import ClaroButton from "../../atoms/ClaroButton";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import ModalCustom from "../ModalCustom";
import styled from "styled-components";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";

const LinkButton = styled.button`
  width: 100%;
  padding: 0px;
  background: #ffffff;
  color: #0f0f0f;
  font-family: "Amx-Bold";
  font-size: 14px;
  line-height: 24px;
  margin: 40px 0px 0px 0px;
  border: none;
  text-decoration: underline;
`;

export default class DomiciliationResponseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDomiciliationResponseModal: false,
      CpMessage: "CP0019",
    };
  }

  componentDidMount() {
    const {
      domiciliationReferenceResponse,
      domicilationReferenceError,
      tagServiceId,
      executeTaggeo,
    } = this.props;
    let action = "";
    let alert_id = "";
    let confirmation_id = "";
    let eventName = "";
    if (!isObjectEmpty(domiciliationReferenceResponse)) {
      const { status } = domiciliationReferenceResponse;
      let CP;
      if (status) {
        CP = "CP0019";
        action = "View confirmation";
        confirmation_id = "Domiciliación exitosa";
        eventName = tagServiceId === "serviciopagotelcelMenu"
          ? "telcel"
          : "pay_service_or_tae";
      } else {
        CP = "CP0005";
        action = "View alert";
        alert_id = "Domiciliación no exitosa";
        eventName = "telcel"
      }
      this.setState({
        openDomiciliationResponseModal: true,
        CpMessage: CP,
      });
    }
    if (domicilationReferenceError) {
      this.setState({
        CpMessage: "CP0005",
        openDomiciliationResponseModal: true,
      });
      action = "View alert";
      alert_id = "Domiciliación no exitosa";
      eventName = "telcel"
    }
    executeTaggeo({
      step: "Pantalla principal",
      service: tagServiceId,
      alert_id: alert_id,
      action: action,
      confirmation_id: confirmation_id,
      eventName: eventName,
    });
  }

  handleOnClickButton = () => {
    const { CpMessage } = this.state;
    const { tagServiceId, executeTaggeo } = this.props;
    this.setState({ openDomiciliationResponseModal: false });
    let action = "";
    let alert_id = "";
    let confirmation_id = "";
    let eventName = "";
    if (CpMessage === "CP0005") {
      action = "Click alert Intentar nuevamente";
      alert_id = "Domiciliación no exitosa";
      eventName = "telcel"
      setTimeout(() => {
        window.history.back();
      }, 500);
    }
    if (CpMessage === "CP0019") {
      action = "Click confirmation Entendido";
      confirmation_id = "Domiciliación exitosa";
      eventName = tagServiceId === "serviciopagotelcelMenu"
        ? "telcel"
        : "pay_service_or_tae"
      const url = '{"app": "goToHome"}';
      setTimeout(() => {
        sdkclaro.getInstance().openNative(url);
      }, 500);
    }
    executeTaggeo({
      step: "Pantalla principal",
      service: tagServiceId,
      alert_id: alert_id,
      action: action,
      confirmation_id: confirmation_id,
      eventName: eventName
    });
  };

  handleOnClickLink = () => {
    const { tagServiceId, executeTaggeo } = this.props;
    this.setState({ openDomiciliationResponseModal: false });
    executeTaggeo({
      step: "Pantalla principal",
      service: tagServiceId,
      alert_id: "Domiciliación no exitosa",
      action: "Click alert Hacerlo en otro momento",
      eventName: "telcel",
    });

    const url = '{"app": "goToHome"}';
    setTimeout(() => {
      sdkclaro.getInstance().openNative(url);
    }, 500);
  };

  render() {
    const { openDomiciliationResponseModal, CpMessage } = this.state;
    const {
      messagesDomiciliation,
      domiciliationReferenceResponse: { expirationDate },
    } = this.props;
    let messageInformation = { data: {} };
    let message = "";
    if (messagesDomiciliation.length !== 0) {
      messageInformation = getMessage(messagesDomiciliation, CpMessage);
      message = messageInformation.data.message;
      if (CpMessage === "CP0019") {
        message = setDomiciliationMsgInitialDate(
          messageInformation.data.message,
          formatEpochDate(expirationDate)
        );
      }
    }
    return (
      <ModalCustom
        isOpen={openDomiciliationResponseModal}
        style={{
          display: "grid",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "#fff",
            margin: "0px 16px",
            borderRadius: "2%",
            textAlign: "center",
          }}
        >
          <img
            src={messageInformation.data.icon}
            alt={""}
            width={"65px"}
            style={{ marginTop: "-10%" }}
          />
          <div
            style={{
              padding: "24px 16px 32px 16px",
            }}
          >
            <ClaroParagraph
              fontSize={"18px"}
              fontColor={"#0f0f0f"}
              fontFamily={"Amx-Bold"}
              align={"center"}
              margin={"0px 0px 16px 0px"}
              display=""
            >
              <section
                dangerouslySetInnerHTML={{
                  __html: messageInformation.data.subject,
                }}
              />
            </ClaroParagraph>
            {messageInformation.data.message ? (
              <ClaroParagraph
                fontSize={"14px"}
                fontColor={"#848484"}
                fontFamily={"Amx-Regular"}
                align={"center"}
                margin={"0px 0px 32px 0px"}
                display=""
              >
                <section dangerouslySetInnerHTML={{ __html: message }} />
              </ClaroParagraph>
            ) : (
              <></>
            )}
            <ClaroButton
              width={"80%"}
              fontSize={"14px"}
              fontFamily={"Amx-Bold"}
              margin={"0px auto"}
              padding={"0px"}
              $isValid={true}
              disabled={false}
              onClick={() => this.handleOnClickButton()}
            >
              {messageInformation.data.buttons[0]}
            </ClaroButton>
            {messageInformation.data.buttons[1] ? (
              <LinkButton onClick={() => this.handleOnClickLink()}>
                {messageInformation.data.buttons[1]}
              </LinkButton>
            ) : (
              <></>
            )}
          </div>
        </div>
      </ModalCustom>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      messagesDomiciliation = [],
      domicilationReferenceError,
      domiciliationReferenceResponse,
    },
  } = state;
  const {
    PAYMENT_SERVICE_CONF: { tagServiceId },
  } = state.payments;
  return {
    messagesDomiciliation,
    domicilationReferenceError,
    domiciliationReferenceResponse,
    tagServiceId,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMessengerService,
      executeTaggeo,
    },
    dispatch
  );
}

DomiciliationResponseModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(DomiciliationResponseModal);
